import { render, staticRenderFns } from "./MessageTemplateInfoActions.vue?vue&type=template&id=4b994f56&scoped=true&"
import script from "./MessageTemplateInfoActions.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateInfoActions.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateInfoActions.vue?vue&type=style&index=0&id=4b994f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b994f56",
  null
  
)

export default component.exports